import { MarkdownInput } from '@react-admin/ra-markdown';
import { useEffect } from 'react';
import { BooleanInput, Create, Datagrid, DateField, DateTimeInput, Edit, FormTab, List, ReferenceField, ReferenceInput, SelectInput, SimpleForm, TabbedForm, TextField, TextInput, useRecordContext } from 'react-admin';
import { ColorBooleanField as BooleanField, MediaPreview, UpdateUrlFieldButton, defaultListFilters, hideFileUpload } from './customized-elements';

export const ContentList = () => (
    <List filters={ defaultListFilters }>
        <Datagrid rowClick="edit" isRowSelectable={(record) => false}
            sort={{ field: 'createdAt', order: 'DESC'}}
        >
            <TextField source="title" />

            <ReferenceField source="typeId" reference="types" label="Type">
                <TextField source="title" />
            </ReferenceField>

            <BooleanField source="status" />
            <DateField source="updatedAt" />
            <ReferenceField source="updatedBy" reference="administrators">
                <TextField source="name" />
            </ReferenceField>
        </Datagrid>
    </List>
)

const ContentTitle = () => {
    const record = useRecordContext();
    return <span>Content {record ? `${record.id}: ${record.title}` : ''}</span>;
}

export const ContentEdit = (props: any) => {

    useEffect(() => {
        hideFileUpload();
    }, [])

    return (
        <Edit title={ <ContentTitle /> } >
            <TabbedForm>
                <FormTab label="Content">
                    <TextInput source="title" fullWidth />
                    <TextInput source="slug" fullWidth />
                    <ReferenceInput source='typeId' reference='types' label='Type' >
                        <SelectInput
                            label="Type"
                            optionText="title"
                        />
                    </ReferenceInput>
                    <MarkdownInput source="body" fullWidth />
                </FormTab>

                <FormTab label="Options">
                    <DateTimeInput source="publishStart" />
                    <DateTimeInput source="publishEnd" />
                    <BooleanInput source="status" />
                    <TextInput source="meta" multiline fullWidth />
                    <TextInput source="posterUrl" fullWidth />
                    <MediaPreview source="posterUrl" />

                    <UpdateUrlFieldButton resource="contents" source="posterUrl" buttonLabel="Update Poster"/>
                </FormTab>
            </TabbedForm>
        </Edit>
    )
}

export const ContentCreate = () => {

    useEffect(() => {
        hideFileUpload();
    }, [])

    return (
        <Create>
            <SimpleForm>
                <TextInput source="title" fullWidth />
                <TextField source="slug" fullWidth />
                <ReferenceInput source='typeId' reference='types' label='Type' >
                    <SelectInput
                        label="Type"
                        optionText="title"
                    />
                </ReferenceInput>
                <MarkdownInput source="body" initialValue=" " fullWidth />
                <TextInput source="posterUrl" fullWidth />
                <BooleanInput source="status" />
            </SimpleForm>
        </Create>
    )
}